<template>
  <div>
    <!-- <div v-if="companies"> -->

    <v-card :loading="loading" class="blueCard" flat>
      <v-card-title>GP Companies</v-card-title
      ><v-card-text>
        <v-btn-toggle
          v-model="filters.type"
          rounded
          class="my-2 my-sm-0 toggleBtns"
          active-class="activeToggle"
        >
          <v-btn small :value="null">All</v-btn>
          <v-btn small value="lenses">Lens Company</v-btn>
          <v-btn small value="materials">Material Company</v-btn>
        </v-btn-toggle>
      </v-card-text>
    </v-card>

    <div class="d-flex flex-row flex-wrap my-6">
      <div
        v-for="compObj in filteredCompanies"
        :key="compObj.id"
        :class="$vuetify.breakpoint.smAndUp ? 'smCard' : 'xsCard'"
      >
        <v-card class="pa-4 text-center">
          <div class="imgDiv">
            <v-img
              v-if="compObj.image"
              :src="logoPath + compObj.image"
              contain
              max-height="50"
            ></v-img>
          </div>

          <div class="font-weight-bold">{{ compObj.name }}</div>

          <div class="d-flex flex-row justify-center my-2">
            <v-btn
              class="mr-1"
              v-if="compObj.lensCount > 0"
              text
              color="primary"
              :to="'/rgps/company/' + compObj.slug"
            >
              <v-img
                :src="iconPath + 'rgp_icon.svg'"
                width="20"
                contain
                class="mr-2"
              ></v-img>
              Lenses</v-btn
            >
            <v-btn
              class="mr-1"
              v-if="compObj.materialCount > 0"
              text
              color="primary"
              :to="'/rgps/materials/' + compObj.slug"
            >
              <v-img
                :src="iconPath + 'rgp_button_icon.svg'"
                width="20"
                contain
                class="mr-2"
              ></v-img>
              Materials</v-btn
            >
          </div>
        </v-card>
      </div>
    </div>
    <!-- 
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="companies"
      :items-per-page="100"
      hide-default-footer
      @click:row="rowClick"
    >
      <template v-slot:item.image="{ item }">
        <v-img
          v-if="item.image"
          :src="logoPath + item.image"
          contain
          max-width="150"
          max-height="50"
          position="left center"
        ></v-img>
      </template>
      <template v-slot:item.lensCount="{ item }">
        <check-or-minus :val="item.lensCount"></check-or-minus
      ></template>
      <template v-slot:item.materialCount="{ item }">
        <check-or-minus :val="item.materialCount"></check-or-minus
      ></template>
    </v-data-table> -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
// import CheckOrMinus from "@/components/universalStuff/CheckOrMinus";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";

export default {
  name: "RgpCompanies",
  props: {
    isAdmin: null,
    // rgpOptions: null,
  },
  components: {
    // CheckOrMinus
  },
  mixins: [FiltersMixin],
  data: function () {
    return {
      loading: false,
      logoPath: "https://www.eyedock.com/images/rgp_companies/",
      iconPath: "https://eyedock.com/images/menu_icons/",
      companies: [],
      filters: { search: null, type: null },
      headers: [
        { text: "Image", value: "image" },
        { text: "Name", value: "name" },
        { text: "Lenses", value: "lensCount" },
        { text: "Materials", value: "materialCount" },
      ],
    };
  },
  methods: {
    getCompanies() {
      this.loading = true;
      ApiServices.genericApiCall("/rgps/companies")
        .then((response) => {
          if (response.data) this.companies = response.data.items;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      console.log(item);
    },
  },
  computed: {
    filteredCompanies: function () {
      let f = this.filters;
      let fCompanies = this.companies.filter((compObj) => {
        if (f.type == "lenses" && compObj.lensCount < 1) return false;
        if (f.type == "materials" && compObj.materialCount < 1) return false;
        return true;
      });
      return fCompanies;
    },
  },
  mounted() {
    this.getCompanies();

    this.prepend_F = false; // (for FiltersMixin)
    this.keysCase = "lower"; // (for FiltersMixin)
    this.setFiltersFromHash();
    if (this.filters.search) this.search = this.filters.search;
  },
  metaInfo() {
    return {
      title: "EyeDock/GPs | Companies",
    };
  },
};
</script>

<style scoped>
.smCard {
  width: 340px;
  padding: 0 1em 1em;
}
.xsCard {
  width: 100%;
  padding: 0.5em 1em;
}
.imgDiv {
  height: 60px;
  width: 200px;
  margin: 0 auto;
}
</style>
